// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'

// Compatibilitat Internet Explorer 11
// npm install --save babel-polyfill
import 'babel-polyfill'

import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import 'material-design-icons-iconfont/dist/material-design-icons.css'

import App from './App'
import router from './router'

import store from './store'

import axios from '@/http-common'

Vue.use(Vuetify)

const moment = require('moment')
require('moment/locale/es')

Vue.use(require('vue-moment'), { moment });

Vue.config.productionTip = false

const token = localStorage.getItem('user-token')

if (token) {
  axios.defaults.headers.common['token'] = token
}

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
